// import React from "react";
// import { observer } from "mobx-react-lite";

// const CustomeZoombar = observer(({ store }) => {
//   const minZoom = 0.1;
//   const maxZoom = 5;

//   function handleZoomChange(event) {
//     const newScale = parseFloat(event.target.value);
//     store.setScale(Math.max(minZoom, Math.min(maxZoom, newScale)));
//   }

//   const handleZoomDropdownChange = (event) => {
//     const selectedZoom = parseFloat(event.target.value / 100);
//     store.setScale(selectedZoom);
//   };

//   console.log("store.scale", store.scale);
//   return (
//     <>
//       <div>
//         <input
//           type="range"
//             min={minZoom}
//             max={maxZoom}
//           //   step="0.1"
//           step="0.01"
//           value={store.scale}
//           style={{width:"300px"}}
//           onChange={handleZoomChange}
//         />
//         <label>{Math.round(store.scale * 100)}%</label>
//       </div>
//       <div className="dropdown-list">
//         <select
//           onChange={handleZoomDropdownChange}
//           value={Math.round(store.scale * 100)}
//         >
//           <option value={`${Math.round(store.scale * 100)}`}>{Math.round(store.scale * 100)}%</option>
//           <option value="10">10%</option>
//           <option value="20">20%</option>
//           <option value="30">30%</option>
//           <option value="40">40%</option>
//           <option value="50">50%</option>
//         </select>
//       </div>
//     </>
//   );
// });

// export default CustomeZoombar;

import React from "react";
import { observer } from "mobx-react-lite";

const CustomeZoombar = observer(({ store }) => {
  const minZoom = 0.01;
  const maxZoom = 2; // range slider from 0 to 2 (half for 0–1, half for 1–5)

  // Convert slider position to actual scale
  const getActualScale = (sliderValue) => {
    if (sliderValue <= 1) {
      return sliderValue; // 0 to 1 maps to 0–1
    } else {
      return 1 + (sliderValue - 1) * 4; // 1 to 2 maps to 1–5
    }
  };

  // Convert actual scale to slider position
  const getSliderValueFromScale = (scale) => {
    if (scale <= 1) {
      return scale;
    } else {
      return 1 + (scale - 1) / 4;
    }
  };

  const handleZoomChange = (event) => {
    const sliderValue = parseFloat(event.target.value);
    const actualScale = getActualScale(sliderValue);
    store.setScale(actualScale);
  };

  const handleZoomDropdownChange = (event) => {
    const selectedZoom = parseFloat(event.target.value) / 100;
    store.setScale(selectedZoom);
  };

  const currentSliderValue = getSliderValueFromScale(store.scale);

  return (
    <>
      <div style={{ width: "300px", marginRight: "10px" }}>
        <input
          type="range"
          min={minZoom}
          max={maxZoom}
          step="0.01"
          value={currentSliderValue}
          onChange={handleZoomChange}
        />
        <label>{Math.round(store.scale * 100)}%</label>
      </div>
      <div className="dropdown-list">
        <select
          onChange={handleZoomDropdownChange}
          value={Math.round(store.scale * 100)}
        >
          <option value={`${Math.round(store.scale * 100)}`}>
            {Math.round(store.scale * 100)}%
          </option>
          <option value="10">10%</option>
          <option value="20">20%</option>
          <option value="30">30%</option>
          <option value="40">40%</option>
          <option value="50">50%</option>
        </select>
      </div>
    </>
  );
});

export default CustomeZoombar;
